module.exports = __webpack_public_path__ + "static/media/samsung-aife-2020-screen-poster.f32e8c6c.jpg";